import { h } from 'vue'
import OrganismCsm from '~/components/organisms/csm/csm.vue'

const Functional = (props) => {
  return h(OrganismCsm, {
    componentCsmSection: {
      ...props.componentCsmSection,
      title: props.record.title || props.componentCsmSection.title,
      text: props.record.text || props.componentCsmSection.text,
    },
    componentGlobal: props.componentGlobal,
  })
}

Functional.props = {
  componentCsmSection: {
    required: true,
    type: Object,
  },
  componentGlobal: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
